var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnitedArabEmirates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1155_2318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47845 20.2174L9.78281 29.0672C11.4077 29.6702 13.1654 30 15.0002 30C21.4496 30 26.9478 25.9294 29.0671 20.2174H8.47845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47845 9.78264L9.78281 0.932871C11.4077 0.329883 13.1654 0 15.0002 0C21.4496 0 26.9478 4.07062 29.0671 9.78264H8.47845Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9992C0 21.4487 4.07068 26.9468 9.78264 29.0662V0.93219C4.07068 3.05158 0 8.54973 0 14.9992Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1155_2318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnitedArabEmirates);
export default __webpack_public_path__ + "static/media/icon-united-arab-emirates.be80bd9fb6453e980536955e56023fa6.svg";
export { ForwardRef as ReactComponent };